import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private storage: LocalStorageService, private router: Router) {

  }
  ngOnInit(): void {
    let user = this.storage.retrieve("user")
    if (user === null) {
      this.router.navigate(['/login']);
    }
    else {
      this.router.navigate(['/home']);
    }
  }
}
